export interface FlinkeyBoxListFilterItem {
  product_id: string;
  serial_number: string;
  vehicle_registration?: string | null;
  car_name?: string | null;
  responsible_for_me?: boolean | number | null;
}

/** Ansvarig på utlämningsplatsen där boxens fordon ligger. */
export function isResponsibleForFlinkeyBox(box: {
  responsible_for_me?: boolean | number | null;
}): boolean {
  return box.responsible_for_me === true || Number(box.responsible_for_me) === 1;
}

export function filterFlinkeyBoxList<T extends FlinkeyBoxListFilterItem>(
  boxes: T[],
  options: { search: string; onlyResponsible: boolean }
): T[] {
  const q = options.search.trim().toLowerCase();
  return boxes.filter((box) => {
    if (options.onlyResponsible && !isResponsibleForFlinkeyBox(box)) return false;
    if (!q) return true;
    return (
      box.product_id.toLowerCase().includes(q) ||
      box.serial_number.toLowerCase().includes(q) ||
      (box.vehicle_registration?.toLowerCase().includes(q) ?? false) ||
      (box.car_name?.toLowerCase().includes(q) ?? false)
    );
  });
}
